import fetchApiWithAuth from './fetch';

export type MpWarehouse = {
  id: number;
  marketplace_auth_id: number;
  marketplace: string;
  external_warehouse_id: string;
  name: string;
  status: string;
  is_active: boolean;
  /** Daily order limit; 0 = off. */
  order_limit: number;
  /** 2+ = объединённый склад МП, собирающий остаток с нескольких физ. складов. */
  self_warehouse_ids: number[];
  self_warehouses: {
    id: number;
    name: string;
    supply_token?: string | null;
  }[];
};

export type SelfWarehouseLinkInput = {
  self_warehouse_id: number;
  supply_token?: string | null;
};

export type RemoteMpWarehouse = {
  external_id: string;
  name: string;
  status: string;
};

async function readError(result: Response, fallback: string): Promise<string> {
  const text = await result.text();
  try {
    const json = JSON.parse(text);
    if (typeof json?.message === 'string') return json.message;
    if (Array.isArray(json?.message)) return json.message.join(', ');
  } catch {
    /* plain text */
  }
  return text || fallback;
}

export async function list(marketplace?: string): Promise<MpWarehouse[]> {
  const qs = marketplace
    ? `?marketplace=${encodeURIComponent(marketplace)}`
    : '';
  const result = await fetchApiWithAuth(`/api/mp_warehouses${qs}`);
  if (!result.ok) throw new Error(await readError(result, 'Ошибка загрузки'));
  return result.json();
}

export async function listRemote(
  marketplace: string,
): Promise<RemoteMpWarehouse[]> {
  const qs = `?marketplace=${encodeURIComponent(marketplace)}`;
  const result = await fetchApiWithAuth(`/api/mp_warehouses/remote${qs}`);
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка загрузки складов МП'));
  }
  return result.json();
}

export async function create(body: {
  marketplace: string;
  external_warehouse_id: string;
  self_warehouse_ids?: number[];
  self_warehouse_links?: SelfWarehouseLinkInput[];
}): Promise<MpWarehouse> {
  const result = await fetchApiWithAuth('/api/mp_warehouses', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка добавления склада МП'));
  }
  return result.json();
}

export async function sync(marketplace: string): Promise<MpWarehouse[]> {
  const result = await fetchApiWithAuth('/api/mp_warehouses/sync', {
    method: 'POST',
    body: JSON.stringify({ marketplace }),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка обновления статусов'));
  }
  return result.json();
}

export async function update(
  id: number,
  body: {
    self_warehouse_ids?: number[];
    self_warehouse_links?: SelfWarehouseLinkInput[];
    name?: string;
    is_active?: boolean;
    order_limit?: number | null;
  },
): Promise<MpWarehouse> {
  const result = await fetchApiWithAuth(`/api/mp_warehouses/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка обновления склада МП'));
  }
  return result.json();
}
